import type { TArg } from '../models';

/**
 * Получить индекс на основе корневой части аргумента
 * @param args Доступные аргументы
 * @param root Корневая часть аргумента
 *
 * @remarks
 * В случае если в `args` не содержит значений,
 * то индекс вычисляется на основе имени корневой части аргумента,
 * например: `$0` => -1, `$1` => 0, `$2` => 1
 */
export const getIndexByArgumentRoot = (args: TArg[], root: string) => {
    if (!args.length) return Number(root.replace(/^\$/g, '')) - 1;

    return args.indexOf(root);
};
